import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import SignatureContainer from "./SignatureContainer";
import './ButtonBar.css';
import './SignatureContainer.css';
import Gallery from "./Gallery";
import axios from "axios";
import './Gallery.css';
import LoadingImage from '../Components/images/loading1.gif'; // Import your loading gif image
import toast from "react-hot-toast";
import backButton from '../Components/images/back_button.png';
import miraeLogo from '../Components/images/logo.svg';
import partnerLogo from '../Components/images/Partners-Logo.svg';
import ainxtlogo from "../Components/images/AinxtTech_logo.png"
import androidlogo from "../Components/images/andriod-app.svg"
import ioslogo from "../Components/images/apple_logo.png"
import closelogo from "../Components/images/popup-cancel.svg"
import api from "./config";
import { language_selected } from "./language";
  


function SignSdk() {
  const navigate = useNavigate();

  const [commitId, setCommitId] = useState('');
  const [source, setSource] = useState('');
  const [, forceUpdate] = useState(0); // Add at the top of your component
  const [loading, setLoading] = useState(false); // Default: no loading
  const [isSignatureDrawn, setIsSignatureDrawn] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [galleryKey, setGalleryKey] = useState(0); // State for reinitializing Gallery
  const signatureCanvasRef = useRef(null);
  const [toastShown, setToastShown] = useState(false);
  const [ipAddress, setIpAddress] = useState("");
  const [cardData, setCardData] = useState({});
  const [showRemark, setShowRemark] = useState(false);
  const sendImageToApiRef = useRef(null);
  const [deviceType, sestDeviceType] = useState('')
  const [isDismissed, setIsDismissed] = useState(false);
  const [userType, setUserType] = useState(""); // Default user_type
  const [projectName, setProjectName] = useState(""); // Default project
  const [requestId, setRequestId] = useState('');
  const [IsShowBanner, setIsShowBanner] = useState('');
  const toastActiveRef = useRef(false);
  const [language_text, setLanguage_text] = useState("english");

  const [isBackRequired, setIsBackRequired] = useState(false);

  // useEffect(() => {
  //   const language = new URLSearchParams(window.location.search).get("language_selected") || "english";
  //   setLanguage_text(language);
  // }, [])

  useEffect(() => {
    const validLanguages = ["english", "marathi", "hindi", "gujarati"]; // add all valid ones

    const urlLang = new URLSearchParams(window.location.search).get("language_selected");

    const language = validLanguages.includes(urlLang) ? urlLang : "english";

    setLanguage_text(language);
  }, []);

  const clearPopupMessage = () => {
    const popup = document.getElementById("popupmessage");
    if (popup) {
      popup.style.display = "none";
    }
  };
  const resetImage = () => {
    // clearImage(); // Call the function to clear the image
    resetCanvas(); // Optionally reset the canvas as well
    // hidePopupMessage(); // Hide the popup when the image is cleared
  };

  const onLeftAngleClick = () => {
    window.parent.postMessage({ "error": "User close the signature" }, "*");
  };

  const onPlayStoreClick = () => {
    window.open('https://mstock.onelink.me/CX05/ycv38g9k', '_blank');
  };

  const onAppStoreClick = () => {
    window.open('https://mstock.onelink.me/CX05/ycv38g9k', '_blank');
  };

  const onCloseClick = () => {
    setUserType('fresh_user_closed_banner')
    setIsDismissed(true);
  };

  const resetCanvas = () => {

    const canvas = signatureCanvasRef.current;
    if (canvas) {
      const context = canvas.getContext("2d");
      context.clearRect(0, 0, canvas.width, canvas.height);
      setIsSignatureDrawn(false);
      // clearPopupMessage(); // Clear popup when resetting the canvas
    }
  };

  const handleSendImageToAPI = async () => {
    if (sendImageToApiRef.current && selectedImage) {
      await sendImageToApiRef.current(selectedImage); // Call the Gallery's sendImageToAPI function
    }
  };

  const showPopupMessage = (message, type) => {
    const popup = document.getElementById("popupmessage");
    if (popup) {  // Add this check to prevent errors if element doesn't exist
      popup.innerHTML = message;
      popup.style.display = "block";
      popup.style.backgroundColor = type === "success" ? "green" : "red";
      setTimeout(() => {
        popup.style.display = "none";
      }, 3000);
    }
  };

  useEffect(() => {
    const deviceType = getDeviceType();
    sestDeviceType(deviceType)

    const r = new URLSearchParams(window.location.search).get("request_id") || "";
    const u = new URLSearchParams(window.location.search).get("user_type") || "";
    const p = new URLSearchParams(window.location.search).get("project_name") || "";
    const IsShowBannerParam = new URLSearchParams(window.location.search).get("IsShowBanner") || "";
    const params = new URLSearchParams(window.location.search);
    const cid = params.get("commit_id");
    const src = params.get("source");

    setCommitId(cid);
    setSource(src);
    if (IsShowBannerParam === 'false') {
      setIsDismissed(true);
    }
    setUserType(u); // Set user_type from URL or default to "diy"  // "fresh" or "rejected" or "dormant"
    setProjectName(p); // Set project_name from URL or default to "   // "diy"  or "partner"
    setRequestId(r)
    setIsShowBanner(IsShowBannerParam);

    // Check for isbackrequired parameter
    const isBack = params.get("isbackrequired");
    setIsBackRequired(isBack === 'true');
  }, [])

  function getDeviceType() {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    if (/windows phone/i.test(ua)) {
      return "Windows Phone";
    }
    if (/android/i.test(ua)) {
      return "Android";
    }
    if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
      return "iOS";
    }
    if (/Win/i.test(ua)) {
      return "Windows";
    }
    if (/Mac/i.test(ua)) {
      return "Mac";
    }
    return "Other";
  }

  // Effect for handling image drawing on the canvas when selectedImage is updated
  useEffect(() => {
    const canvas = signatureCanvasRef.current;
    if (canvas && selectedImage) {
      const context = canvas.getContext("2d");
      const image = new Image();
      image.onload = () => {
        resetCanvas(); // Clear the canvas before drawing a new image
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
      };
      image.src = selectedImage; // Set the uploaded image as the source
    }
  }, [selectedImage]);

  useEffect(() => {
    const canvas = signatureCanvasRef.current;
    if (canvas && !selectedImage) {
      const context = canvas.getContext("2d");

      const devicePixelRatio = window.devicePixelRatio || 1;
      const canvasDisplayWidth = canvas.clientWidth * devicePixelRatio;
      const canvasDisplayHeight = canvas.clientHeight * devicePixelRatio;
      canvas.width = canvasDisplayWidth;
      canvas.height = canvasDisplayHeight;
      context.scale(devicePixelRatio, devicePixelRatio);

      let isDrawing = false;
      let lastX = 0;
      let lastY = 0;

      const getMousePos = (e) => {
        const rect = canvas.getBoundingClientRect();
        return {
          x: e.clientX - rect.left,
          y: e.clientY - rect.top,
        };
      };

      const startDrawing = (e) => {
        isDrawing = true;
        const { x, y } = getMousePos(e);
        lastX = x;
        lastY = y;
        toastActiveRef.current = false; // <-- Reset flag when drawing starts
        // setToastShown(false);
      };

      const draw = (e) => {
        if (!isDrawing) return;
        const { x, y } = getMousePos(e);

        if (
          x < 0 ||
          y < 0 ||
          x > canvas.width / (window.devicePixelRatio || 1) ||
          y > canvas.height / (window.devicePixelRatio || 1)
        ) {

          // isDrawing = false;
          // toast.error("Signature went out of the box! Please stay within the area.");
          // // resetCanvas()
          // forceUpdate(n => n + 1); // Force re-render to show the message

          // setTimeout(() => {
          //   toastActiveRef.current = false;
          //   forceUpdate(n => n + 1); // Force re-render to hide the message
          // }, 2000);

          if (!toastActiveRef.current) {
            toastActiveRef.current = true;
            isDrawing = false;
            resetCanvas();
            forceUpdate(n => n + 1); // Force re-render to show the message
            setTimeout(() => {
              toastActiveRef.current = false;
              forceUpdate(n => n + 1); // Force re-render to hide the message
            }, 2000);
          }

          return;
        }



        context.strokeStyle = "#000000ff"; // Set stroke color to black
        context.lineWidth = 2.0;

        context.beginPath();
        context.moveTo(lastX, lastY);
        context.lineTo(x, y);
        context.stroke();

        lastX = x;
        lastY = y;

        setIsSignatureDrawn(true);
      };

      const stopDrawing = () => {
        isDrawing = false;
      };

      // Attach listeners for drawing
      canvas.addEventListener("mousedown", startDrawing);
      canvas.addEventListener("mousemove", draw);
      canvas.addEventListener("mouseup", stopDrawing);

      canvas.addEventListener("touchstart", (e) => {
        e.preventDefault();
        const touch = e.touches[0];
        startDrawing(touch);
      });

      canvas.addEventListener("touchmove", (e) => {
        e.preventDefault();
        const touch = e.touches[0];
        draw(touch);
      });

      canvas.addEventListener("touchend", stopDrawing);

      return () => {
        // Clean up the event listeners when the component unmounts or the canvas is reset
        canvas.removeEventListener("mousedown", startDrawing);
        canvas.removeEventListener("mousemove", draw);
        canvas.removeEventListener("mouseup", stopDrawing);
        canvas.removeEventListener("touchstart", startDrawing);
        canvas.removeEventListener("touchmove", draw);
        canvas.removeEventListener("touchend", stopDrawing);
      };
    }
  }, [selectedImage]);

  const fetchIpAddress = async () => {
    try {
      const response = await axios.get('https://api.ipify.org?format=json');
      setIpAddress(response.data.ip);
    } catch (error) {
      console.error('Error fetching the IP address:', error);
    }
  };

  const handleSubmit = async () => {
    // Ensure a signature is drawn or an image is uploaded
    // console.log('requestId', requestId);
    if (!isSignatureDrawn && !selectedImage) {
      showPopupMessage(
        language_selected[language_text].draw_or_upload,
        "error"
      );

      return;
    }

    try {
      setLoading(true); // Show loading indicator
      await fetchIpAddress(); // Fetch IP address for the request

      // If an image has been selected, call the sendImageToAPI function
      if (selectedImage) {
        await handleSendImageToAPI(); // Assuming this sends the selected image to the API
        setLoading(false); // Hide loading and return as the image has been processed
        return;
      }

      // If a signature is drawn, get the base64 data from the canvas
      const canvas = signatureCanvasRef.current;
      const base64Data = canvas.toDataURL().replace("data:image/png;base64,", "");

      // Create FormData and append the base64 signature data
      const formData = new FormData();
      const payload = `b'${base64Data}'`; // Prepare the payload
      formData.append('image', payload); // Append as key-value pair

      // Prepare the request config
      const config = {
        method: "post",
        // url: `https://vumjbhw69h.execute-api.ap-south-1.amazonaws.com/default/signaturevalidate?Isdigital=1&IsSdk=1`,
        url: `${api.BASE_URL}/default/JM_pro_signvalidate_uat?Isdigital=1&IsSdk=1`,
        headers: {
          "x-api-key": api.x_api_key,
          "authorizationToken": api.authorizationToken,
        },
        data: formData, // Send FormData as the payload
      };

      // Send the API request for signature validation
      const response = await axios(config);

      // Update card data with the server response
      setCardData(response.data);
      setLoading(false); // Hide loading indicator

      // Show any remarks or errors from the server response
      if (response.data.status !== 1) {
        const errorMessage =
          language_selected[language_text]?.invalid_sign || response.data.remark;

        showPopupMessage(errorMessage, "error");
      }


      // If the response status is successful, send the success message to the parent window
      if (response.data.status === 1) {
        let requestDataToSend = { ...response.data};
        // console.log("data", requestDataToSend);
        // console.log(requestDataToSend, "this is the complete response");
        toast.success(language_selected[language_text]?.success, {
          style: {
            background: '#13CF5D', // faint green
            color: 'white',        // white text
            border: 'none',
          },
          iconTheme: {
            primary: 'white',
            secondary: '#13CF5D',  // medium green circle
          },
        });
console.log(requestDataToSend);

        window.parent.postMessage(requestDataToSend, "*");

      }
      else {
        // Hide remarks section if the status is not successful
        resetCanvas()
        // setSelectedImage(null);
        // resetGallery(); // Reset Gallery component
        // clearPopupMessage(); // Clear popup when image is cleared
        setTimeout(() => {
          setShowRemark(false);
        }, 1000);
      }

    } catch (error) {
      // Handle errors during the API call
      setLoading(false); // Hide loading indicator
      showPopupMessage(language_selected[language_text].server_error_simple, "error");

      window.parent.postMessage({ "error": error.message }, "*");
    }
  };

  console.log('toastActiveRef', toastActiveRef.current);


  // Function to reset Gallery by changing its key
  const resetGallery = () => {
    setGalleryKey(prevKey => prevKey + 1); // Increment the key to re-render Gallery
  };

  return (
    <React.Fragment>
      <div id="popupmessage" className="errorWindow" style={{ display: "none" }}></div>
      {
        toastActiveRef.current && (
          <div
            style={{
              position: "fixed",
              top: "5%",
              left: '50%',
              transform: 'translate(-50%, -50%)',
              background: "#fff",
              border: "1px solid #f5c2c7",
              borderRadius: "8px",
              padding: "12px 16px",
              display: "flex",
              alignItems: "center",
              boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
              // maxWidth: "320px",
              width: "22rem",
              zIndex: 1000,
            }}
          >
            {/* Red circle with X icon */}
            <div
              style={{
                background: "#f8d7da",
                color: "#d32f2f",
                borderRadius: "50%",
                width: "24px",
                height: "23px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "10px",
                flexShrink: 0,
              }}
            >
              <span style={{ fontWeight: "bold" }}>×</span>
            </div>

            {/* Message */}
            <span style={{ color: "#333", fontSize: "14px", flex: 1 }}>
              {language_selected[language_text]?.pop_up}
            </span>
          </div>)
      }


      {/* {
        userType === "fresh" ? <>
          {
            deviceType !== "Windows" &&
            <>
              {!isDismissed && (
                <>
                  <div className="app-banner" id="appbanner">
                    <p className="mb-0">
                      <a href="https://mstock.onelink.me/CX05/ycv38g9k" target="_new" rel="noreferrer" style={{ textDecoration: 'none', color: 'black' }}>
                        For better experience, download our app

                        {
                          deviceType === "Android" && <img
                            src={androidlogo}
                            width="16"
                            alt="Google Play"
                            className="app-icon"
                            onClick={onPlayStoreClick}
                            style={{ marginLeft: '8px' }}
                          />
                        }
                        {
                          deviceType === "iOS" &&
                          <img
                            src={ioslogo}
                            width="40"
                            alt="App Store"
                            className="app-icon"
                            onClick={onAppStoreClick}
                            style={{ marginLeft: '8px' }}
                          />
                        }
                      </a>
                    </p>
                    <span>
                      <a href="javascript:;" id="cancelbanner">
                        <img src={closelogo} alt="cancel" onClick={onCloseClick} />
                      </a>
                    </span>
                  </div>

                </>
              )}
            </>
          }
        </> : <></>
      } */}
      {
        deviceType !== "Windows" &&
        <>
          {!isDismissed && (
            <>
              {/* <div className="app-banner" id="appbanner">
                <p className="mb-0">
                  <a href="https://mstock.onelink.me/CX05/ycv38g9k" target="_new" rel="noreferrer" style={{ textDecoration: 'none', color: 'black' }}>
                    For better experience, download our app

                    {
                      deviceType === "Android" && <img
                        src={androidlogo}
                        width="14"
                        alt="Google Play"
                        className="app-icon"
                        onClick={onPlayStoreClick}
                        style={{ marginLeft: '12px' }}
                      />
                    }
                    {
                      deviceType === "iOS" &&
                      <img
                        src={ioslogo}
                        width="30"
                        alt="App Store"
                        className="app-icon"
                        onClick={onAppStoreClick}
                        style={{ marginLeft: '8px', marginTop: '-2px' }}
                      />
                    }
                  </a>
                </p>
                <span>
                  <a href="javascript:;" id="cancelbanner">
                    <img src={closelogo} alt="cancel" onClick={onCloseClick} />
                  </a>
                </span>
              </div> */}

            </>
          )}
        </>
      }
      {/* <div className="logoMarginSet">

        <div style={{ display: 'flex', alignItems: 'center', order: 1, width: '200px' }}>
          {isBackRequired && (
            <img src={backButton} width="20" height="auto" style={{ marginTop: '10px', marginRight: "3px", cursor: "pointer" }} onClick={onLeftAngleClick} />
          )}
          <><img src={ainxtlogo} width="120" height="auto" style={{ marginLeft: '10px' }} /></>
          {
            projectName === "partner" ? <><img src={partnerLogo} width="200" height="auto" style={{ marginLeft: '5px' }} /></> : <><img src={miraeLogo} width="120" height="auto" style={{ marginLeft: '0rem', marginTop: '10px' }} /></>
          }
        </div>

        <div style={{ width: '230px', order: 3 }}></div>
       
    


      </div> */}
      <SignatureContainer
        resetCanvas={resetCanvas}
        signatureCanvasRef={signatureCanvasRef}
        base64Image={selectedImage}
        language_text={language_text}
        clearImage={() => {
          setSelectedImage(null);
          resetGallery(); // Reset Gallery component
          clearPopupMessage(); // Clear popup when image is cleared
        }}
      >
        {/* <div className="text-center font18 marginSetOR">{language_selected[language_text]?.breakline_text}</div> */}
        <Gallery
          key={galleryKey} // This will force Gallery to re-render when the key changes
          isSignatureDrawn={isSignatureDrawn}
          setSelectedImageInParent={setSelectedImage}
          passSendImageToAPI={(fn) => { sendImageToApiRef.current = fn; }} // Pass the function reference
          userType={userType}
          projectName={projectName}
          language_text={language_text}
        />

        <div className="submit-button-container bottomCaptureNowBtn">
          {loading && (
            <div className="loadingImgGalleryPage">
              <img src={LoadingImage} alt="Loading..." style={{ width: "150px", height: "auto" }} />
            </div>
          )}
          <button
            className="btn clearBtnInRow"
            onClick={() => {
              setSelectedImage(null);
              resetGallery();
              clearPopupMessage();
              resetCanvas();
            }}
          >
            {language_selected[language_text]?.clear_text}
          </button>
          <button
            className="btn mobFullWidth"
            onClick={handleSubmit}
          >
            {language_selected[language_text]?.btn_text}
          </button>
        </div>
        
       
      </SignatureContainer>
 
    </React.Fragment>
  );
}

export default SignSdk;
